export default {
  colors: {
    primary: "#E50914",
    background: "#FFFFFF",
    shape: `#F2F2FA`,
    title: `#020A14`,
    text: `#6C6C80`,
    components: {
      blockquote: {
        background: `#FEF3C7`,
        text: `#020A14`,
      },
    },
  },
  fonts: {
    fontFace: {
      family:
        "-apple-system, BlinkMacSystemFont, San Francisco, Ubuntu, Helvetica Neue, Helvetica, Roboto, Noto, Segoe UI, Arial, sans-serif",
    },
    body: "-apple-system, BlinkMacSystemFont, San Francisco, Ubuntu, Helvetica Neue, Helvetica, Roboto, Noto, Segoe UI, Arial, sans-serif",
  },
};
